(() => {
 if (customElements.get('hh-labor-event')) return;
 const formatter = new Intl.DateTimeFormat('en-US', {timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
 const parts = ms => Object.fromEntries(formatter.formatToParts(new Date(ms)).filter(p=>p.type!=='literal').map(p=>[p.type,Number(p.value)]));
 function nextMidnight(ms) {
  const p=parts(ms), d=new Date(Date.UTC(p.year,p.month-1,p.day+1));
  const target=Date.UTC(d.getUTCFullYear(),d.getUTCMonth(),d.getUTCDate());
  let guess=target+4*3600000;
  for(let i=0;i<3;i++){const q=parts(guess);guess+=target-Date.UTC(q.year,q.month-1,q.day,q.hour,q.minute,q.second);}
  return guess;
 }
 class HHLaborEvent extends HTMLElement {
  connectedCallback(){this.start=Date.parse(this.dataset.start);this.end=Date.parse(this.dataset.end);this.tick();this.interval=setInterval(()=>this.tick(),1000);}
  disconnectedCallback(){clearInterval(this.interval);}
  tick(){
   const now=Date.now(), active=now>=this.start&&now<this.end;
   this.toggleAttribute('data-active',active);
   const content=this.querySelector('[data-event-content]'),fallback=this.querySelector('[data-event-fallback]');
   if(content)content.hidden=!active;if(fallback)fallback.hidden=active;
   if(!active||this.dataset.mode!=='header')return;
   const left=Math.max(0,Math.ceil((nextMidnight(now)-now)/1000));
   const values=[Math.floor(left/3600),Math.floor(left%3600/60),left%60];
   ['hours','minutes','seconds'].forEach((unit,i)=>{const el=this.querySelector('[data-'+unit+']');if(el)el.textContent=String(values[i]).padStart(2,'0');});
  }
 }
 customElements.define('hh-labor-event',HHLaborEvent);
})();
